// CSS Modules - component class name: NaviSelectCascading__

<template>
  <div class="columns">
    <div
      :class="[
        $style.cascading,
        $style.container,
        'column is-half-tablet is-half-desktop'
      ]"
      @mouseenter="mouseenterEvent(0)"
      @mouseleave="open[0] && mouseleaveEvent(0), open[0] && mouseleaveEvent(1)"
      @click="clickEvent(0)"
    >
      <a :class="getSelectClasses(0)">
        <span
          v-if="selectedEntryId && selectedEntry"
          v-html="selectedEntry.label"
        ></span>
        <span v-else v-html="config.defaultLabel" />
        <span :class="$style.triangle"></span>
      </a>
      <ul>
        <li
          v-for="entry in config.entries"
          :key="`entry${entry.id}`"
          :class="{
            [$style.active]: entry.id == selectedEntryId
          }"
        >
          <a v-if="entry.url" :href="entry.url" v-html="entry.label"></a>
          <a
            v-else
            @click="selectEntry($event, entry.id)"
            v-html="entry.label"
          ></a>
        </li>
      </ul>
    </div>
    <div
      v-if="config.cascading && children.length"
      :class="[$style.cascading, $style.container, 'column is-half']"
      @mouseenter="mouseenterEvent(1)"
      @mouseleave="mouseleaveEvent(1)"
      @click="clickEvent(1)"
    >
      <a :class="getSelectClasses(1)">
        <span
          v-if="selectedChildId && selectedChild"
          v-html="selectedChild.label"
        />
        <span v-else v-html="config.defaultLabel" />
        <span :class="$style.triangle"></span>
      </a>
      <ul>
        <li
          v-for="child in children"
          :key="`entry${selectedEntryId}-child${child.id}`"
          :class="{
            [$style.active]: child.id == selectedChildId
          }"
        >
          <a v-if="child.url" :href="child.url" v-html="child.label"></a>
          <a v-else v-html="child.label"></a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "NaviSelectCascading",
  props: {
    config: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      open: [false, false],
      noHover: [false, false],
      selectedEntryId: null,
      selectedChildId: null
    };
  },
  computed: {
    selectedEntry: function() {
      return (
        (this.config.entries &&
          this.config.entries.find(
            entry => entry.id == this.selectedEntryId
          )) ||
        null
      );
    },
    children: function() {
      return (this.selectedEntry && this.selectedEntry.children) || [];
    },
    selectedChild: function() {
      return this.getChildById(this.selectedChildId);
    }
  },
  methods: {
    checkScreenSize() {
      window.innerWidth < 780
        ? (this.isMobile = true)
        : (this.isMobile = false);
    },
    getChildById(childId) {
      return (
        (this.children && this.children.find(child => child.id == childId)) ||
        null
      );
    },
    getSelectClasses(level) {
      return [
        {
          [this.$style.blue]: this.config.colour === "blue",
          [this.$style.white]: this.config.colour === "white",
          [this.$style.orange]: this.config.colour === "orange",
          [this.$style.noHover]: this.noHover[level],
          [this.$style.open]: this.open[level]
        },
        this.$style.select
      ];
    },
    clickEvent(number) {
      this.$set(this.open, number, true);
    },
    mouseenterEvent(number) {
      this.$set(this.noHover, number, true);
    },
    mouseleaveEvent(number) {
      window.setTimeout(() => {
        this.$set(this.open, number, false);
        this.$set(this.noHover, number, false);
      }, 1000);
    },
    setInitialSelectedChild() {
      if (this.config.selectedChild) {
        this.selectedChildId = this.config.selectedChild;
      } else {
        this.getSelectedChildFromUrl();
      }
    },
    getSelectedChildFromUrl() {
      const params = window.location.search.substr(1).split("&");
      const naviSelectedParam = params.find(param =>
        param.includes("naviSelectedChild")
      );
      const naviSelectedParamValue = naviSelectedParam
        ? naviSelectedParam.split("=")[1]
        : null;
      this.selectedChildId = this.getChildById(naviSelectedParamValue)
        ? naviSelectedParamValue
        : null;
    },
    selectEntry(event, entryId) {
      if (event) {
        event.stopPropagation();
      }

      const isClicked = !!entryId;
      this.selectedEntryId = entryId || this.config.selectedEntry;

      // Populate list of children in the second dropdown
      if (this.selectedEntryId) {
        if (isClicked) {
          this.selectedChildId = null;
          this.clickEvent(1);
          this.mouseenterEvent(1);
        } else {
          this.setInitialSelectedChild();
        }
      }

      if (this.isMobile) {
        // close first select on mobile to prevent overlaying eachother
        this.$set(this.open, 0, false);
      }
    }
  },
  mounted() {
    window.addEventListener("resize", this.checkScreenSize);
    this.checkScreenSize();
    this.selectEntry();
  }
};
</script>

<style module lang="scss">
@import "./NaviSelectCascading.scss";
</style>
